import { CSSProperties, FC, PropsWithChildren } from "react"
import style from "./SbtH5.module.css"

type Props = PropsWithChildren & {
	styles?: CSSProperties
}
/* SBT - H5 16pt semibold */
export const SbtH5: FC<Props> = ({ children, styles }) => {
	return (
		<h5 className={style.sbtH5} style={styles}>
			{children}
		</h5>
	)
}
